import axios from "axios"

//const
const USER_DETAILS_GET_INFO = "editUserDetails/USER_DETAILS_GET_INFO"
const USERINFO_DETAILS_GET_INFO = "editUserDetails/USERINFO_DETAILS_GET_INFO"
const USERINFO_DETAILS_UPDATE = "editUserDetails/USERINFO_DETAILS_UPDATE"
const USER_DETAILS_UPDATE = "editUserDetails/USER_DETAILS_UPDATE"

//reducer
export const editUserDetails = (state = {
  user: {
    username: "",
    email: "",
    phone: "",
  },
  userinfo: {
    metadata: "",
    avatar: "",
  },
}, action) => {
  switch (action.type) {
    case USER_DETAILS_GET_INFO: {
      console.log("debug: ", action.data)
      let newUserInfo = {
        username: action.data.username,
        email: action.data.email,
        phone: action.data.phone,

      }
      return {
        ...state,
        user: newUserInfo
      }
    };

    case USERINFO_DETAILS_GET_INFO: {
      console.log("debug: ", action.data)
      let userInfoUpdate = [];
      if (action.data.avatar === null || action.data.avatar === undefined) {
        userInfoUpdate = {
          metadata: action.data.metadata,
          avatar: "24dd932a187949579e35e8af7cfd352e.jpg", // user default logo
        }
      }else{
        userInfoUpdate = {
          metadata: action.data.metadata,
          avatar: action.data.avatar,
        }
      }
      return {
        ...state,

        userinfo: userInfoUpdate
      }
    }
      ;
    case USERINFO_DETAILS_UPDATE:
      return {
        ...state,
        userinfo: {
          ...state.userinfo,
          [action.data.name]: action.data.value
        }
      };

    case USER_DETAILS_UPDATE:
      return {
        ...state,
        user: {
          ...state.user,
          [action.data.name]: action.data.value
        }
      };
    default:
      return state
  }
}


// action
export const getUserDetails = (userId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/users?userId=" + userId;

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log(response.data);
        dispatch(getUserDetailsDone(response.data))
      }
    })
}

export const getUserInfoDetails = (userId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/userInfoes?userId=" + userId;

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("get", response.data);
        dispatch(getUserInfoDetailsDone(response.data))
      }
    })
}

export const getUserDetailsDone = (data) => {
  return {
    type: USER_DETAILS_GET_INFO,
    data: data
  }
}

export const getUserInfoDetailsDone = (data) => {
  return {
    type: USERINFO_DETAILS_GET_INFO,
    data: data
  }
}

export const updateData = (data) => {
  return {
    type: USERINFO_DETAILS_UPDATE,
    data: data
  }
};

export const update = (data) => {
  return {
    type: USER_DETAILS_UPDATE,
    data: data
  }
};
